import { useState } from 'react';
import { activateNeverUpstaged, activateSpellcharge } from '../services/SimpleTokenService';

/**
 * useHPDamageMode - Custom hook to manage HP damage mode (Never Upstaged, Spellcharge)
 * @returns {object} { hpDamageMode, activationMessages, toggleHPDamageMode, handleHPDamageWithMode }
 */
const useHPDamageMode = () => {
  const [hpDamageMode, setHpDamageMode] = useState(null); // null, 'never-upstaged', 'spellcharge'
  const [activationMessages, setActivationMessages] = useState([]);

  // Toggle HP damage mode (orange for Never Upstaged, purple for Spellcharge)
  const toggleHPDamageMode = (mode) => {
    if (hpDamageMode === mode) {
      setHpDamageMode(null); // Turn off if already active
    } else {
      setHpDamageMode(mode); // Switch to new mode
    }
  };

  // Handle automatic HP damage activation based on current mode
  const handleHPDamageWithMode = async (hpDamageAmount, updatedCharacter, getSpellcastTrait, allData) => {
    let finalCharacter = updatedCharacter;
    const messages = [];

    if (hpDamageMode === 'never-upstaged') {
      const neverUpstagedResult = activateNeverUpstaged(finalCharacter, hpDamageAmount);
      if (neverUpstagedResult.activated) {
        finalCharacter = neverUpstagedResult.character;
        messages.push(neverUpstagedResult.message);
      }
    } else if (hpDamageMode === 'spellcharge') {
      // Get the spellcast trait for this character
      const spellcastTrait = getSpellcastTrait(finalCharacter, allData);
      const spellchargeResult = activateSpellcharge(finalCharacter, hpDamageAmount, spellcastTrait);
      if (spellchargeResult.activated) {
        finalCharacter = spellchargeResult.character;
        messages.push(spellchargeResult.message);

        // Auto-reset mode when max tokens reached
        if (spellchargeResult.shouldResetMode) {
          setTimeout(() => {
            setHpDamageMode(null);
          }, 2000); // Reset after 2 seconds to let user see the message
        }
      }
    }

    setActivationMessages(messages);

    // Show activation messages briefly
    if (messages.length > 0) {
      setTimeout(() => setActivationMessages([]), 3000);
    }

    return finalCharacter;
  };

  return {
    hpDamageMode,
    activationMessages,
    toggleHPDamageMode,
    handleHPDamageWithMode
  };
};

export default useHPDamageMode;
